var React = require('react');

function Inputform (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M20.832 25V20.832H70.832V25H20.832ZM20.832 37.5V33.332H70.832V37.5H20.832ZM20.832 50V45.832H62.5V50H20.832ZM20.832 62.5V58.332H70.832V62.5H20.832ZM83.332 58.332H79.1679V10.418C79.1679 9.26573 78.2343 8.33213 77.082 8.33213H14.582C13.4336 8.33213 12.5 9.26572 12.5 10.418V85.418C12.5 86.5664 13.4336 87.5 14.582 87.5H50V91.668H14.582C11.1328 91.668 8.332 88.8672 8.332 85.418V10.418C8.332 6.96493 11.1328 4.16803 14.582 4.16803H77.082C80.5351 4.16803 83.332 6.96493 83.332 10.418V58.332ZM90 65.4179L93.332 67.9179L73.27 94.6719L59.082 82.8519L61.75 79.6488L72.566 88.6644L90 65.4179Z","fill":"black"}));
}

Inputform.defaultProps = {"width":"100","height":"100","viewBox":"0 0 100 100","fill":"none"};

module.exports = Inputform;

Inputform.default = Inputform;
